class CommerceRequest {
    constructor() {

    }

    get(url, opts) {
        opts = opts || {};
        opts.onSuccess = opts.onSuccess || function (response) {
            console.error('Request sent with no onSuccess handler', response);
        };

        new Promise(function (resolve, reject) {
            function reqListener() {
                resolve(this.responseText);
            }

            function reqError(err) {
                reject(err);
            }

            let oReq = new XMLHttpRequest();
            oReq.onload = reqListener;
            oReq.onerror = reqError;

            oReq.open('get', url + '&_commerce_ajax=1&HTTP_MODAUTH=' + MODx.siteId, true);
            oReq.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

            oReq.send();
        }).then(function (response) {
            opts.onSuccess(response);
        });

    }
}
